import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    PDFMaker: {
        
    }
}));


export default useStyles;